export const LOGO_URL =
  "/img/logo.webp";

export const WHATSAPP_LINK = "https://wa.link/ncq0f0";

export const DOCTOR_DESK =
  "/img/bbl-banner-3.webp";
export const DOCTOR_HEART =
  "/img/doctor-heart.png";

export const FOLLOWUP_GROUPS = [
  {
    group: "Antecedentes y hábitos",
    items: [
      ["motivo_control", "Motivo del control"],
      ["factores_riesgo", "Factores de riesgo"],
      ["alergias", "Alergias"],
      ["habitos", "Hábitos"],
      ["app", "APP"],
      ["apqx", "APQX"],
      ["medicacion", "Medicación"],
      ["actividad_fisica", "Actividad física"],
      ["vacuna_covid", "Vacuna Covid"],
    ],
  },
  {
    group: "Examen físico y signos",
    items: [
      ["cuadro_clinico", "Cuadro clínico"],
      ["ex_fisico_respiratorio", "Ex. Físico — Respiratorio"],
      ["ex_fisico_cardiovascular", "Ex. Físico — Cardiovascular"],
      ["igy", "IGY"],
      ["sv", "SV"],
      ["imc", "IMC"],
      ["ecg_reposo", "ECG en reposo"],
    ],
  },
];

export const CLINIC = {
  name: "CardioBaus",
  doctor: "Dr. Bolívar Baus",
  tagline: "Cardiología Integral",
  phone: "+593 96 318 8089",
  email: "citas@cardiobaus.com",
  address: "Av. Joaquín Orrantia y Av. Juan Tanca Marengo, Edif. Ágora XXI, Piso 5, Consultorio 510 · Guayaquil",
  hours: [
    { d: "Lunes a Viernes", h: "09:30 – 17:00" },
    { d: "Sábados", h: "10:00 – 15:00" },
    { d: "Domingos", h: "Cerrado" },
  ],
};
